// extracted by mini-css-extract-plugin
export default {"menu-bar":"MenuBarIcon_menu-bar__nVcwF","mob-active":"MenuBarIcon_mob-active__6VD8+"};